var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFabric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "001-fabric") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 34 0 34 33.9946875 0 33.9946875"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mapa-5",
    transform: "translate(-14.000000, -6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "001-fabric",
    transform: "translate(14.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6953125,29.3515625 C9.6953125,28.9849115 9.39790104,28.6875 9.03125,28.6875 L4.6484375,28.6875 C4.28178646,28.6875 3.984375,28.9849115 3.984375,29.3515625 C3.984375,29.7182135 4.28178646,30.015625 4.6484375,30.015625 L9.03125,30.015625 C9.39790104,30.015625 9.6953125,29.7182135 9.6953125,29.3515625 Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3359375,6.7734375 L13.6796875,6.7734375 L13.6796875,4.6484375 C13.6796875,2.08524479 11.5944427,0 9.03125,0 L4.6484375,0 C2.08524479,0 0,2.08524479 0,4.6484375 L0,11.7535521 C0,12.1205573 0.297411458,12.4176146 0.6640625,12.4176146 C1.03071354,12.4176146 1.328125,12.1205573 1.328125,11.7535521 L1.328125,4.6484375 C1.328125,2.81775 2.81775,1.328125 4.6484375,1.328125 L9.03125,1.328125 C10.8619375,1.328125 12.3515625,2.81775 12.3515625,4.6484375 L12.3515625,26.1028802 C11.5073177,25.2398646 10.3310417,24.703125 9.03125,24.703125 L4.6484375,24.703125 C3.4074375,24.703125 2.23983854,25.186651 1.36097396,26.0648073 C1.34990625,26.075875 1.33919271,26.0880052 1.328125,26.0994271 L1.328125,17.7304688 C1.328125,17.3638177 1.03071354,17.0664062 0.6640625,17.0664062 C0.297411458,17.0664062 0,17.3638177 0,17.7304688 L0,29.3515625 C0,31.9147552 2.08524479,34 4.6484375,34 L33.3359375,34 C33.7025885,34 34,33.7025885 34,33.3359375 L34,7.4375 C34,7.07084896 33.7025885,6.7734375 33.3359375,6.7734375 Z M23.1000781,8.1015625 L32.671875,17.6733594 L32.671875,24.2466042 L16.5268333,8.1015625 L23.1000781,8.1015625 Z M32.671875,15.7953906 L24.9780469,8.1015625 L32.671875,8.1015625 L32.671875,15.7953906 Z M14.6484219,8.1015625 L32.671875,26.1250156 L32.671875,32.671875 L32.6448698,32.671875 L13.6796875,13.7066927 L13.6796875,8.1015625 L14.6484219,8.1015625 Z M24.1925938,32.671875 L13.6796875,22.1582604 L13.6796875,15.5851042 L30.7664583,32.671875 L24.1925938,32.671875 Z M1.328125,29.3515625 C1.328125,27.5122865 2.81739583,26.03125 4.6484375,26.03125 L9.03125,26.03125 C10.8619375,26.03125 12.3515625,27.520875 12.3515625,29.3515625 C12.3515625,31.1908385 10.8622917,32.671875 9.03125,32.671875 L4.6484375,32.671875 C2.81775,32.671875 1.328125,31.18225 1.328125,29.3515625 Z M13.6796875,29.3515625 L13.6796875,24.0366719 L22.3142708,32.671875 L12.2833854,32.671875 C13.192,31.7830052 13.6796875,30.5976979 13.6796875,29.3515625 Z",
    id: "Fill-3",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2,14 C2,14.5521333 1.55213333,15 1,15 C0.447866667,15 0,14.5521333 0,14 C0,13.4473333 0.447866667,13 1,13 C1.55213333,13 2,13.4473333 2,14 Z",
    id: "Fill-5",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFabric);
export default __webpack_public_path__ + "static/media/icon-fabric.4d5a48da8e21b572f3d3273a2db6db17.svg";
export { ForwardRef as ReactComponent };